class WebApi {
  static instance;

  static getInstance() {
    if (!WebApi.instance) {
      const instance = new WebApi();
      this.instance = instance;
      window.webJSBridge = {
        nativeCallJS: instance.nativeCallJS,
        actionCallback: {},
      };
    }
    return this.instance;
  }

  nativeCallJS(param) {
    let parseParams = {};
    try {
      parseParams = param;
    } catch (error) {
      console.error(error);
    }
    console.log('nativeCallJS接收：', param);
    const { actionName, parameters } = parseParams;
    console.log('actionName：', actionName);
    console.log('parameters：', parameters);
    if (!actionName) {
      console.error('actionName不存在，请检查');
      return;
    }
    if (window.webJSBridge.actionCallback[actionName]) {
      window.webJSBridge.actionCallback[actionName](parameters);
    }
  }

  subscribeAction(actionName, callback) {
    if (!callback) {
      return;
    }
    window.webJSBridge.actionCallback[actionName] = callback;
    console.log(`已注册订阅方法${actionName}`);
  }
}

export default WebApi;



// WEBPACK FOOTER //
// ./src/common/js/bridge/WebApi.js